import { isValid, parse } from 'date-fns';
import isAfter from 'date-fns/isAfter';

import { ValidationResults } from '../types/types';

export const validateInputs = (
  params: Record<string, string>,
): ValidationResults => {
  const validationResults: ValidationResults = {
    valid: true,
    errors: {},
    validValues: {},
  };

  const adults = params.adults;
  if (!adults.match(/^\d+$/)) {
    validationResults.valid = false;
    validationResults.errors.adults = 'Invalid number of adults';
  } else {
    validationResults.validValues.adults = adults;
  }

  const children = params.children;
  if (!children.match(/^\d+$/)) {
    validationResults.valid = false;
    validationResults.errors.children = 'Invalid number of children';
  } else {
    validationResults.validValues.children = children;
  }

  const now = new Date();
  const date = params.date;
  const dateObj = parse(date, 'yyyy-MM-dd', now);

  if (!isValid(dateObj)) {
    validationResults.valid = false;
    validationResults.errors.date = 'Invalid date';
  } else {
    validationResults.validValues.date = date;
  }

  const time = params.time;
  const timeRegex24Hour = /^([01]\d|2[0-3]):([0-5]\d)$/;
  const timeRegex12Hour = /^(0[1-9]|1[0-2]):([0-5]\d) (AM|PM)$/;
  let datetimeFormat: string;
  if (timeRegex24Hour.test(time)) {
    validationResults.validValues.time = time;
    datetimeFormat = 'yyyy-MM-dd HH:mm';
  } else if (timeRegex12Hour.test(time)) {
    validationResults.validValues.time = time;
    datetimeFormat = 'yyyy-MM-dd hh:mm a';
  } else {
    validationResults.valid = false;
    validationResults.errors.time = 'Invalid time format';
  }

  if (validationResults.valid) {
    const dateTimeString = `${params.date} ${params.time}`;
    const dateTimeObj = parse(dateTimeString, datetimeFormat, now);

    if (!isAfter(dateTimeObj, now)) {
      validationResults.valid = false;
      validationResults.errors.datetime = 'Selected timeslot is in the past';
    }
  }

  return validationResults;
};
